<template>
  <div>
    <div class="gradient-overlay"></div>
    <section v-if="loggedUser" class="main-content">
      <GridBox>
        <GridItem
          size="100%"
          :colidx="1"
          class="p-5 height-auto"
          glassy
          v-if="!mobile"
        >
          <GridBody class="m-0">
            <div
              class="is-size-3 has-text-primary-alt has-text-weight-bold mb-2"
            >
              {{ this.$store.getters["public-auth/authedUser"].firstName }}
            </div>

            <b-navbar-item
              v-if="loggedUser && loggedUser.accountDeleteRequest === null"
              tag="router-link"
              class="menu-item logged-menu-item is-subtle"
              :to="localePath('/u/manage')"
            >
              <b-icon icon="fas fa-cog" size="is-small" class="mx-1" />
              {{ $t("profile.manageAccount") }}
            </b-navbar-item>
            <b-navbar-item
              @click.native="authLogout()"
              tag="router-link"
              class="menu-item logged-menu-item logout-item"
              icon-right="fas fa-sign-out-alt"
              :to="localePath('/u')"
            >
              <b-icon icon="fas fa-sign-out-alt" size="is-small" class="mx-1" />
              Logout
            </b-navbar-item>
          </GridBody>
        </GridItem>
        <GridItem
          size="100%"
          :colidx="2"
          class="p-5"
          glassy
          v-if="
            loggedUser.memberships &&
            loggedUser.memberships.length > 0 &&
            loggedUser.accountDeleteRequest === null
          "
        >
          <GridBody class="m-0">
            <div class="is-size-3 is-subtle has-text-weight-bold">
              {{ $t("profile.memberships.title") }}
            </div>

            <MembershipCard
              v-for="membership in loggedUser.memberships"
              :key="membership.id"
              :mobile="mobile"
              :tesserato="membership"
              :error="false"
              :class="loggedUser.memberships.length === 2 ? 'mt-3' : ''"
            />

            <b-button
              v-if="loggedUser.memberships.length < 2 && !loggedUser.void"
              tag="router-link"
              :to="localePath('/u/membership')"
              class="is-uppercase is-size-6 primary-btn"
              :class="loggedUser.memberships.length > 0 ? 'mt-3' : ''"
              icon-left="fas fa-id-card"
            >
              {{ $t("profile.memberships.request") }}
            </b-button>
            <div
              v-if="!mobile"
              class="card-content px-6 pt-0 has-text-centered content is-subtle"
            >
              {{ $t("profile.memberships.qrCode") }}
            </div>
          </GridBody>
        </GridItem>
        <GridItem
          size="100%"
          :colidx="2"
          class="p-5"
          glassy
          v-if="
            loggedUser.memberships &&
            loggedUser.memberships.length === 0 &&
            !loggedUser.void &&
            loggedUser.accountDeleteRequest === null
          "
        >
          <GridBody class="m-0">
            <div class="is-size-3 mb-3 is-subtle has-text-weight-bold">
              {{ $t("profile.memberships.empty") }}
            </div>

            <!-- <div class="is-size-5 is-subtle has-text-weight-bold">
                            Recupera una tessera ricevuta via e-mail.
                        </div> -->
            <b-button
              tag="router-link"
              :to="localePath('/u/membership')"
              class="is-uppercase is-size-6 primary-btn has-text-weight-bold"
              icon-left="fas fa-id-card"
            >
              {{ $t("profile.memberships.request") }}
            </b-button>
          </GridBody>
        </GridItem>
        <GridItem
          size="100%"
          :colidx="1"
          class="p-5"
          glassy
          v-if="tickets && tickets.length > 0"
        >
          <GridBody class="m-0">
            <div class="is-size-3 is-subtle has-text-weight-bold">
              {{ $t("profile.tickets.title") }}
            </div>

            <UpcomingTicketCard
              v-for="ticket in tickets"
              :key="ticket.id"
              :mobile="mobile"
              :ticket="ticket"
              :error="false"
              class="mb-3"
            />
          </GridBody>
        </GridItem>
        <GridItem
          size="100%"
          :colidx="2"
          class="p-5"
          glassy
          colored
          bgrgba="80, 47, 30"
          v-if="
            loggedUser?.accountDeleteRequest &&
            loggedUser?.accountDeleteRequest?.id
          "
        >
          <GridBody class="m-0 stretch between">
            <div class="is-size-3 is-subtle has-text-weight-bold card-title">
              {{ $t("manageAccount.deleteAccountRequested.title") }}
            </div>
            <div class="is-size-6 has-text-weight-bold mb-2 is-primary-alt">
              {{ $t("manageAccount.deleteAccountRequested.requestedOn") }}
              {{
                new Date(
                  loggedUser?.accountDeleteRequest?.createdAt
                ).toLocaleDateString($i18n.locale, {
                  year: "numeric",
                  month: "numeric",
                  day: "numeric",
                  hour: "2-digit",
                  minute: "2-digit",
                })
              }}
            </div>
            <div class="is-size-6 has-text-weight-normal mb-2">
              {{ $t("manageAccount.deleteAccountRequested.description") }}
            </div>
          </GridBody>
        </GridItem>
      </GridBox>
    </section>
  </div>
</template>

<style lang="scss" scoped>
.card-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  border-radius: 1rem;
}
.card {
  width: 100%;
  overflow: auto;
}
// .card-content {
//     // margin: 0;
//     // width: 100%;
//     // overflow: auto;
//     // padding: 2rem;
// }
.menu-item {
  margin: 0;
  padding: 0.5rem 0;
  font-size: 1rem;
  text-transform: uppercase;
  font-weight: bold;
}
.col-content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
}

.hero {
  @media (max-width: 960px) {
    max-width: 90vw;
    margin: 2rem 0;
  }
}
.gradient-overlay {
  transition: all 0.2s ease-in-out;
  opacity: 0.5;
  pointer-events: none;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
  width: 100%;
  overflow: hidden;
  height: 90vh;
  width: 100%;
  background: linear-gradient(
    180deg,
    rgba(var(--color-primary-alt-rgba), 0.25) 0%,
    rgba(var(--color-primary-alt-rgba), 0) 100%
  );
  /* background: red; */
}
.main-content {
  /* padding-bottom: 5rem; */
  max-width: 1280px;
  height: 100% !important;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  /* margin-bottom: 2rem; */
  padding: 1rem;
}
</style>
<script>
const CHECK_USER = /* GraphQL */ `
  query check {
    authenticatedPublicUtente {
      id
      email
      firstName
      lastName
      active
      void
      accountDeleteRequest {
        id
        createdAt
      }
      memberships {
        valid
        id
        nationalId
        fiscalCode
        dob
        address
        createdAt
        acceptsMarketing
        expires
        citizenship
        city
        country
        type {
          name
          nameEn
        }
      }
    }
  }
`;

import * as Cookies from "js-cookie";
import MembershipCard from "~/components/app/MembershipCard";
import UpcomingTicketCard from "~/components/app/UpcomingTicketCard.vue";
import GridBody from "~/components/GridBody";
import GridBox from "~/components/GridBox";
import GridItem from "~/components/GridItem";
import { apiBaseName, gql } from "~/utils/gql";

export default {
  name: "Profile",

  data() {
    return {
      pageTitle: "TDF*P — " + this.$t("profile.meta.title"),
      upcomingEvents: [],
      loggedUser: {},
      tickets: [],
      mobile: this.$store.getters["getIsMobile"],
    };
  },
  components: {
    MembershipCard,
    UpcomingTicketCard,
    GridBox,
    GridItem,
    GridBody,
  },
  layout: "default",
  mounted() {
    this.mobile = this.$store.getters["getIsMobile"];

    this.$nextTick(function () {
      this.mobile = this.$store.getters["getIsMobile"];
    });

    window.addEventListener("resize", this.handleResize);
    this.$store.commit("setCurrPageTitle", this.$t("profile.header"));
    if (this.$store.getters["public-auth/authedUser"].id) {
      this.enterAnimation();
      this.$fetch();
      this.$store.commit(
        "setLoggedIn",
        true
        // { root: true }
      );
    } else {
      this.$store.dispatch("setLoggedIn", false);
      this.$router.push(this.localePath("/u/login"));
    }
  },
  watch: {
    $route(to, from) {
      this.$store.commit("setCurrPageTitle", this.$t("profile.header"));
    },
  },
  head() {
    return {
      title: this.pageTitle,
    };
  },
  async fetch() {
    if (this.$store.getters["public-auth/authedUser"].id) {
      const { data } = await gql(CHECK_USER, {
        id: this.$store.getters["public-auth/authedUser"].id,
      });
      const tickets = await this.$axios.$post(`${apiBaseName}/api/tickets`, {
        // headers: { Authorization: `Bearer ${token}` },
        id: this.$store.getters["public-auth/authedUser"].id,
      });
      if (tickets && tickets.length > 0) {
        this.tickets = tickets;
      }
      if (data && data.authenticatedPublicUtente) {
        if (data.authenticatedPublicUtente.active) {
          data.authenticatedPublicUtente.memberships =
            data.authenticatedPublicUtente.memberships.filter(
              (m) => m.expires > new Date().toISOString()
              // && m.valid
            );
          this.loggedUser = data.authenticatedPublicUtente;
          this.$store.commit(
            "public-auth/SET_USER",
            {
              id: data.authenticatedPublicUtente.id,
              email: data.authenticatedPublicUtente.email,
              firstName: data.authenticatedPublicUtente.firstName,
              lastName: data.authenticatedPublicUtente.lastName,
            }
            // { root: true }
          );
        } else {
          // this.$store.dispatch("setLoggedIn", false);
          this.$router.push(this.localePath("/u/confirm/trigger"));
        }
      } else {
        this.$store.dispatch("setLoggedIn", false);
        this.$router.push(this.localePath("/u/login"));
      }
    }
  },
  methods: {
    handleResize() {
      this.mobile = this.$store.getters["getIsMobile"];
    },
    async authLogout() {
      try {
        // console.log(
        //     "browser base url: " + process.env.BROWSER_BASE_URL
        // );
        const isDev = process.env.NODE_ENV !== "production";

        await this.$store.dispatch("auth/logout");
        await this.$store.dispatch("public-auth/logout");
        await this.$store.dispatch("auth/refresh");
        await this.$store.dispatch("public-auth/refresh");
        // console.log("logout: " + logout);
        if (
          this.$cookies &&
          this.$cookies.get("authrefToken") &&
          this.$cookies.get("authrefToken").length > 0
        ) {
          Cookies.remove("authrefToken", {
            path: "/",
            domain: isDev ? "localhost" : process.env.BROWSER_BASE_URL,
          });
        }
        this.$store.dispatch("setLoggedIn", false);
        // refresh the page
        this.$router.push(this.localePath("/u/login"));

        // this.$router.go();
      } catch (e) {
        console.error(e);
      } finally {
      }
    },
    enterAnimation() {
      const anime = this.$anime;
      anime({
        targets: ".main-content",
        easing: "easeInOutQuad",
        opacity: [0, 1],
        filter: ["blur(2rem)", "blur(0px)"],
        duration: 360,
      });
    },
  },
};
</script>
